import React from "react"
import classNames from "classnames"

import styles from "./styles.module.scss"

interface Props {
	mobilaHiddenClassName?: string
	rowClassName?: string
	promptClassName?: string
	columnClassName?: string
	textArea2ClassName?: string
	className?: string
	headingClassName?: string
	data: {
		heading?: string | JSX.Element // Заголовок h2
		textarea?: string | JSX.Element // Описание
		textarea2: string | JSX.Element // Описание 2
		prompt?: JSX.Element // Подсказка
		mediaContent?: JSX.Element // Обычно медия под описанием
		mediaContent2?: JSX.Element // Обычно медия под описанием
		align?: string // Выравнивание блоков
	}
}

// Компонент заголовок, описание и подсказка слева
// Пример: /secret/ohmybowl
export default function HeadingTextareaAndPrompt(props: Props) {
	const data = props.data || []

	return (
		<section className={classNames(styles.container, props.className)}>
			<div
				className={classNames(
					styles.content__row,
					data.align,
					props.rowClassName,
					props.mobilaHiddenClassName
				)}
			>
				{data.prompt && (
					<div
						className={classNames(
							styles.content__column,
							props.promptClassName
						)}
					>
						{data.prompt}
					</div>
				)}

				<div
					className={classNames(
						{
							[styles.content__column_alone]: !data.prompt,
							[styles.content__column]: data.prompt,
						},
						props.columnClassName
					)}
				>
					{data.heading && (
						<h2 className={classNames(styles.heading, props.headingClassName)}>
							{data.heading}
						</h2>
					)}
					{data.textarea && <p className={styles.textarea}>{data.textarea}</p>}
					{data.mediaContent && data.mediaContent}
					{data.textarea2 && (
						<p
							className={classNames(styles.textarea2, props.textArea2ClassName)}
						>
							{data.textarea2}
						</p>
					)}
					{data.mediaContent2 && data.mediaContent2}
				</div>

				{data.prompt2 && (
					<div className={styles.content__column}>{data.prompt2}</div>
				)}
			</div>
		</section>
	)
}
